import Banners from "./banners";
import BannerZoneModel from "../model/banner_zone";
import { BannerPosition } from "../enum/banner";

class BannersExternal extends Banners {

    init(): void {
    }

    reloadVideoBanners(): void {
    }

    getPreOrPostRoll(type: string): Promise<BannerZoneModel | null> {
        let url = this.options.isMobile ? this.options.ads.mobilePrerollUrl : this.options.ads.prerollUrl;
        let position = BannerPosition.PREROLL;

        if (type === 'postroll') {
            url = this.options.isMobile ? this.options.ads.mobilePostrollUrl : this.options.ads.postrollUrl;
            position = BannerPosition.POSTROLL;
        }

        return Promise.resolve(new BannerZoneModel({
                position: position,
                banner: {
                    vastUrl: url,
                    iframeAppendUrl: '',
                    isVpaid: true,
                    posterUrl: false,
                }
            }));
    }
}

export default BannersExternal;